module.exports = __webpack_public_path__ + "static/media/skärm-min.639ba0ce.png";